// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"904b226ff778f9ef3f8a","655":"cf05aeee0f741afdf26b"}[chunkId] + ".js";
};